import { Action } from '../actions';

const defaultState = {
  loading: true,
  txs: [],
  total: 0,
  offset: 0,
  limit: 10,
  type: 'all',
  end: Date.now() + (3600 * 1000),
};

export default function (payState = defaultState, action) {
  switch (action.type) {
    case Action.Payment.Dwolla.CancelConfirmationRequested:
      return {
        ...payState,
        cancelCandidate: action.payload,
      };
    case Action.Payment.Dwolla.CancelCancel:
      return {
        ...payState,
        cancelCandidate: null,
      };
    case Action.Payment.Dwolla.CancelPending:
      return {
        ...payState,
        canceling: true,
      };
    case Action.Payment.Dwolla.CancelCompleted:
      return {
        ...payState,
        canceling: false,
      };
    case Action.Payment.Dwolla.SetPageSize:
      if (payState.limit !== action.payload) {
        return {
          ...payState,
          limit: action.payload,
        };
      }
      break;
    case Action.Payment.Dwolla.BalanceLoaded:
      if (payState.balance !== action.payload.body.balance) {
        return {
          ...payState,
          balance: action.payload.body.balance,
        };
      }
      break;
    case Action.Payment.Dwolla.LoadPending:
      if (!payState.loading) {
        return {
          ...payState,
          loading: true,
        };
      }
      break;
    case Action.Payment.Dwolla.LoadCompleted:
    {
      const { error, body, request } = action.payload;
      if (!error) {
        return {
          ...payState,
          ...request.query,
          loading: false,
          total: body.total,
          txs: body.transfers,
        };
      }
      return {
        ...payState,
        loading: false,
        error,
      };
    }
    default:
      break;
  }
  return payState;
}
